module.exports = __webpack_public_path__ + "static/021-cca6b87910bffc80e89133f0e192e04c.jpg";